<template>
  <b-modal
    ref="confirmModal"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    footer-bg-variant=""
    hide-header
    scrollable>

    <b-alert
      variant="light-danger"
      show
      class="mb-8">
      <p class="font-size-lg mb-0">
        Disabling a tariff will prevent the creation of new resellers under that tariff. Existing resellers will remain unaffected, and the tariff will continue to operate according to its current parameters even when turned off.
      </p>
    </b-alert>

    <b-list-group class="mb-0">
      <b-list-group-item class="d-flex align-items-center">
        Name
        <span class="ml-auto">{{ markedForSwitchTariff.name }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Code
        <span class="ml-auto">{{ markedForSwitchTariff.code }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Devices
        <b-badge
          variant="light"
          class="ml-auto"
          pill>{{ markedForSwitchTariff.devices }}</b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Users
        <b-badge
          variant="light"
          class="ml-auto"
          pill>{{ markedForSwitchTariff.users }}</b-badge>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('confirmModal')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          @click="switchTariff(), hideModal('confirmModal')">
          Yes, disable it
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { SWITCH_TARIFF } from '@/core/services/store/tariffs.module'
import { showModal, hideModal } from '@/core/utils'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
  name: 'ModalDisableTariff',
  data() {
    return {
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'markedForSwitchTariff',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    switchTariff() {
      this.$store.dispatch(SWITCH_TARIFF)
    },
  }
}
</script>
